/**
 * KAN-959: какие разделы свёрнуты (массив кодов в localStorage).
 * Хранилище недоступно или испорчено - всё развёрнуто, сворачивание работает без памяти.
 */
import { useCallback, useState } from 'react';
import { loadJson, saveJson } from '@/lib/persistedState';

/** Ключ свёрнутых разделов списка "Требуют внимания". */
export const ATTENTION_COLLAPSED_STORAGE_KEY = 'smeta.attentionSections.collapsed';

function readCodes(storageKey: string): string[] {
  const raw = loadJson(storageKey);
  return Array.isArray(raw) ? raw.filter((code): code is string => typeof code === 'string') : [];
}

export interface CollapsedSections {
  isCollapsed: (code: string) => boolean;
  toggle: (code: string) => void;
}

export function useCollapsedSections(storageKey: string = ATTENTION_COLLAPSED_STORAGE_KEY): CollapsedSections {
  const [collapsed, setCollapsed] = useState<string[]>(() => readCodes(storageKey));

  const isCollapsed = useCallback((code: string) => collapsed.includes(code), [collapsed]);

  const toggle = useCallback(
    (code: string) => {
      setCollapsed((prev) => {
        const next = prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code];
        saveJson(storageKey, next);
        return next;
      });
    },
    [storageKey]
  );

  return { isCollapsed, toggle };
}
